import { useState } from "react";

import { useDealEventProperties } from "../../organisms/deal-event-properties/use-cases/deal-event-properties-use-cases";
import { Events, track } from "../../utils/analytics";

const Details = ({ title, children, trackingId }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const dealEventProperties = useDealEventProperties();

  const toggle = () => {
    const properties = { ...dealEventProperties, block: trackingId, title };
    const eventName = isExpanded ? Events.BLOCK_COLLAPSED : Events.BLOCK_EXPANDED;

    setIsExpanded(!isExpanded);

    track(eventName, properties);
  };

  return (
    <details className="ml-details">
      <summary onClick={toggle}>{title}</summary>
      <div className="content">{children}</div>
    </details>
  );
};

export default Details;
